<template>
  <section>
    <div class="page">
      <div>
        <h2>Creating and inviting into groups</h2>
        <h3>Creating a group</h3>
        <p>To create a group:</p>
        <ol>
          <li>Go to the Chats tab in ToTok.</li>
          <li>Tap “⊕” at the top right > <strong>Create Group</strong>.</li>
          <ul>
            <li>
              Note: “Instant Group” feature enables you to create a new group or
              join an existing group by entering identical digits.
            </li>
          </ul>
          <li>
            Search for or select contacts to add to the group. Then tap
            <strong>Confirm</strong>.
          </li>
          <li>
            Type in a group name. This will be the name of the group that all
            participants will see.
          </li>
          <ul>
            <li>The subject limit is 20 characters.</li>
            <li>
              Optionally, add a group icon by tapping the Camera icon, where you
              can Take Photo, Select from Photos. Once set, the icon will appear
              next to the group in the Chats tab.
            </li>
          </ul>
          <li>Tap <strong>Confirm</strong> when you're finished.</li>
        </ol>

        <h3>Inviting into groups</h3>
        <p>
          Invite people to join groups simply by sharing a Group link with them.
          To share a Group link:
        </p>
        <ol>
          <li>Go to the group in ToTok, then tap the group name at the top.</li>
          <li>Tap <strong>Share Group</strong>.</li>
          <li>Share the Group Link via ToTok, Whatsapp, SMS, and more.</li>
        </ol>
        <p>
          To invite people to join groups, simply share a Group QR Code with
          them. To share a Group QR Code:
        </p>
        <ol>
          <li>Go to the group in ToTok, then tap the group name at the top.</li>
          <li>Tap <strong>Group QR Code</strong>.</li>
          <li>
            Tap <strong>More “…”</strong> icon at the top right >
            <strong>Forward to Friends</strong>.
          </li>
          <li>
            Search for or select contacts or groups. Then tap
            <strong>OK</strong>.
          </li>
        </ol>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
